











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { FilterParams, AdvancedFilter } from '../store/modules/records/types';

@Component
export default class RecordListFilter extends Vue {
  @Prop(Function) private getKeys: any;
  @Prop(Function) private filterRecords: any;
  @Prop(Function) private filterAdvancedRecords: any;
  @Prop(Function) private setFilterColumn: any;
  @Prop(Function) private setFilterValueType: any;
  @Prop(Function) private setNotEqualExpr: any;
  @Prop(Function) private refreshTable: any;
  @Prop(Function) private addCondition: any;
  @Prop(Function) private removeCondition: any;
  @Prop(Function) private resetAdvancedFilter: any;
  @Prop(Boolean) private filtered!: boolean;
  @Prop(Boolean) private useAdvancedFilter!: boolean;
  @Prop(Object) private filterParams!: FilterParams;
  @Prop(Object) private advancedFilter!: AdvancedFilter;
  @Prop(Object) private headerType!: { [key: string]: string };

  private showDialog: boolean = false;

  private typeOptions: string[] = ['number', 'string', 'null', 'boolean'];

  private allExpressions: string[] = ['=', '!=', '<', '>', '<=', '>=', 'begins_with', 'contains', 'not contains'];

  private expressionsForType(valueType: string): string[] {
    switch (valueType) {
      case 'number': return ['=', '!=', '<', '>', '<=', '>='];
      case 'boolean':
      case 'null': return ['=', '!='];
      default: return this.allExpressions;
    }
  }

  private onConditionColumnSelect(index: number, item: { value: string }) {
    const condition = this.advancedFilter.conditions[index];
    if (condition && this.headerType && this.headerType[item.value]) {
      condition.valueType = this.headerType[item.value];
    }
  }

  private onConditionTypeChange(index: number, valueType: string) {
    const condition = this.advancedFilter.conditions[index];
    if (!condition) { return; }
    if (valueType === 'null') {
      condition.value = null;
      condition.expr = '=';
    } else if (valueType === 'boolean') {
      condition.value = true;
      condition.expr = '=';
    }
  }

  private openAdvancedDialog() {
    // Pre-populate first condition from inline bar if it has data
    if (
      this.filterParams.filterColumn &&
      this.advancedFilter.conditions.length === 1 &&
      !this.advancedFilter.conditions[0].column
    ) {
      const first = this.advancedFilter.conditions[0];
      first.column = this.filterParams.filterColumn;
      first.expr = this.filterParams.filterExpr;
      first.value = this.filterParams.filterValue;
      first.valueType = this.filterParams.valueType;
    }
    this.showDialog = true;
  }

  private applyAdvancedFilter() {
    this.showDialog = false;
    this.filterAdvancedRecords();
  }

  private clearAdvancedFilter() {
    this.resetAdvancedFilter();
    this.refreshTable();
  }
}
